(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    


  const UNMATCHING_COUNTRIES = {
  Afghanistan: 'Afghanistan',
  Albania: 'Albania',
  Algeria: 'Algeria',
  Armenia: 'Armenia',
  Austria: 'Austria',
  Azerbaijan: 'Azerbaijan',
  Bahrain: 'Bahrain',
  Bangladesh: 'Bangladesh',
  Belarus: 'Belarus',
  Belgium: 'Belgium',
  Benin: 'Benin',
  Bhutan: 'Bhutan',
  Bolivia: 'Bolivia, Plurinational State of',
  'Bosnia and Herzegovina': 'Bosnia and Herzegovina',
  Brazil: 'Brazil',
  'British Virgin Islands': 'Virgin Islands, British',
  Bulgaria: 'Bulgaria',
  Burundi: 'Burundi',
  Cambodia: 'Cambodia',
  Cameroon: 'Cameroon',
  'Cape Verde': 'Cape Verde',
  'Central African Republic': 'Central African Republic',
  Chad: 'Chad',
  China: 'China',
  Comoros: 'Comoros',
  Congo: 'Congo',
  'Côte d’Ivoire': "Cote d'Ivoire",
  Croatia: 'Croatia',
  Cyprus: 'Cyprus',
  'Czech Republic': 'Czech Republic',
  Denmark: 'Denmark',
  'Dominican Republic': 'Dominican Republic',
  Egypt: 'Egypt',
  'Equatorial Guinea': 'Equatorial Guinea',
  Estonia: 'Estonia',
  'Faroe Islands': 'Faroe Islands',
  'Finland (Suomi)': 'Finland',
  'French Guiana': 'French Guiana',
  'French Polynesia': 'French Polynesia',
  Georgia: 'Georgia',
  Germany: 'Germany',
  Ghana: 'Ghana',
  Greece: 'Greece',
  Greenland: 'Greenland',
  Guinea: 'Guinea',
  'Guinea-Bissau': 'Guinea-Bissau',
  Hungary: 'Hungary',
  Iceland: 'Iceland',
  India: 'India',
  Iran: 'Iran, Islamic Republic of',
  Iraq: 'Iraq',
  Israel: 'Israel',
  Italy: 'Italy',
  Japan: 'Japan',
  Jordan: 'Jordan',
  Kazakhstan: 'Kazakhstan',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Kyrgyzstan',
  Laos: "Lao People's Democratic Republic",
  Latvia: 'Latvia',
  Lebanon: 'Lebanon',
  Libya: 'Libya',
  Lithuania: 'Lithuania',
  Macau: 'Macao',
  Macedonia: 'Macedonia, the former Yugoslav Republic of',
  Madagascar: 'Madagascar',
  Mauritania: 'Mauritania',
  Mauritius: 'Mauritius',
  Mexico: 'Mexico',
  Moldova: 'Moldova, Republic of',
  Mongolia: 'Mongolia',
  Montenegro: 'Montenegro',
  Morocco: 'Morocco',
  Mozambique: 'Mozambique',
  Myanmar: 'Myanmar',
  Namibia: 'Namibia',
  Nepal: 'Nepal',
  'New Caledonia': 'New Caledonia',
  Netherlands: 'Netherlands',
  Niger: 'Niger',
  'North Korea': "Korea, Democratic People's Republic of",
  Norway: 'Norway',
  Oman: 'Oman',
  Pakistan: 'Pakistan',
  Palestine: 'Palestine',
  Panama: 'Panama',
  Peru: 'Peru',
  Poland: 'Poland',
  Qatar: 'Qatar',
  Réunion: 'Reunion',
  Romania: 'Romania',
  Russia: 'Russian Federation',
  'Saint Helena': 'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Barthélemy': 'Saint Barthélemy',
  'Saint Martin': 'Saint Martin (French part)',
  'Saint Pierre and Miquelon': 'Saint Pierre and Miquelon',
  'São Tomé and Príncipe': 'Sao Tome and Principe',
  'Saudi Arabia': 'Saudi Arabia',
  Senegal: 'Senegal',
  Serbia: 'Serbia',
  'Sint Maarten': 'Sint Maarten (Dutch part)',
  Slovakia: 'Slovakia',
  Slovenia: 'Slovenia',
  Somalia: 'Somalia',
  'South Korea': 'Korea, Republic of',
  'South Sudan': 'South Sudan',
  Spain: 'Spain',
  'Sri Lanka': 'Sri Lanka',
  Sudan: 'Sudan',
  Sweden: 'Sweden',
  Switzerland: 'Switzerland',
  Syria: 'Syrian Arab Republic',
  Taiwan: 'Taiwan',
  Tanzania: 'Tanzania, United Republic of',
  Thailand: 'Thailand',
  Tunisia: 'Tunisia',
  Turkey: 'Turkey',
  Venezuela: 'Venezuela, Bolivarian Republic of',
  'U.S. Virgin Islands': 'Virgin Islands, U.S.',
  Ukraine: 'Ukraine',
  'United Arab Emirates': 'United Arab Emirates',
  Uzbekistan: 'Uzbekistan',
  Vietnam: 'Vietnam',
  Yemen: 'Yemen',
};
  
  function getCountryCodeNodes() {
    return document.querySelectorAll('.hs-fieldtype-intl-phone>select.hs-input');
  }

  // Query country selection form
  function getCountrySelectionNodes() {
    return document.querySelectorAll('.hs-country input');
  }
  
  // Query country choices in form
  function getCountryChoices() {
    return Array.from(getCountryCodeNodes().item(0).querySelectorAll('option')).reduce(
      (acc, country) => {
        acc[country.value] = country.innerHTML.replace(/ *\([^)]*\) */g, '').trim();
        return acc;
      },
      {}
    );
  }
  // Queries default country from phone and establishes default country in country field
  function setSelectedDefaultNodeCountry(
    countryCodeNodes,
    countrySelectionNodes,
    countryChoices
  ) {
    countryCodeNodes.forEach((countryCodeNode) => {
      const countryCode = countryCodeNode.value;
      const countryName = countryChoices[countryCode];
      countrySelectionNodes.forEach((countrySelectionNode) => {
        countrySelectionNode.value =
          countryName ?? UNMATCHING_COUNTRIES[countryName] ?? countryChoices['US'];
      });
    });
  }
  
  function hubspotFormChangeCountry() {
    const countryCodeNodes = getCountryCodeNodes();
    const countrySelectionNodes = getCountrySelectionNodes();
    const countryChoices = getCountryChoices();
  
    setSelectedDefaultNodeCountry(countryCodeNodes, countrySelectionNodes, countryChoices);
  
    countryCodeNodes.forEach((countryCodeNode) => {
      countryCodeNode.addEventListener('change', (e) => {
        const countryCode = (e.target).value;
        const countryName = countryChoices[countryCode];
        countrySelectionNodes.forEach((countrySelectionNode) => {
          countrySelectionNode.value =
            UNMATCHING_COUNTRIES[countryName] ?? countryName ?? countryChoices['US'];
        });
      });
    });
  }

  if(document.getElementById("openModal1")){
    document.getElementById("openModal1").onclick = function() {
      document.getElementById("modal1").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    }

    document.getElementById("closeModal1").onclick = function() {
      document.getElementById("modal1").style.display = "none";
      document.body.style.position = '';
      document.body.style.top = '';
    }

  }


  if(document.getElementById("openModal2")){
    document.getElementById("openModal2").onclick = function() {
      document.getElementById("modal2").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    }

    document.getElementById("closeModal2").onclick = function() {
      document.getElementById("modal2").style.display = "none";
      document.body.style.position = '';
      document.body.style.top = '';
    }
  }

  if(document.getElementById("openModal3")){
    document.getElementById("openModal3").onclick = function() {
      document.getElementById("modal3").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    }
  }

  if(document.getElementById("closeModal3")){
    document.getElementById("closeModal3").onclick = function() {
      document.getElementById("modal3").style.display = "none";
      document.body.style.position = '';
      document.body.style.top = '';
    }
  }

  const triggers = document.querySelectorAll('a[href="#modal3"], button[href="#modal3"]');
  triggers.forEach(el => {
    el.addEventListener("click", e => {
      e.preventDefault();               // stop the browser from jumping to #modal3
      document.getElementById("modal3").style.display = "block";
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
    });
  });

  window.addEventListener('load', function () {
    hubspotFormChangeCountry();
  })

window.onclick = function(event) {
  if (event.target == document.getElementById("modal1")) {
    document.getElementById("modal1").style.display = "none";
  }
  if (event.target == document.getElementById("modal2")) {
    document.getElementById("modal2").style.display = "none";
  }
  if (event.target == document.getElementById("modal3")) {
    document.getElementById("modal3").style.display = "none";
  }
}

  
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
